module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Regular.6746bef.eot";